import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'

import {Paper,Snackbar} from '@material-ui/core'

import { AgGridReact } from 'ag-grid-react'

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

import Moment from 'moment-timezone'

import ActionCellRenderer from '../components/action-cell-renderer'

import callAccountsApi from '../data-provider'
import { normaliseBinaryPayload, printIframeDocument } from '../components/utils'
import { gridPaperStyle } from '../components/grid-shell'

import VATDetail from './vat-detail'

import getGridConfig from './grid-config'
import Config from '../config'

const styles = theme => ({
  paper: gridPaperStyle(120),
})

class Vat extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = {returns:[],selectedVatReturn:null,vat_id:null,message:"",detail_mode:"view",authtoken:null}
  }

  async componentDidMount() {
    let {vat_id} = this.props.match.params

    if (vat_id)
    {
      let userData = Config.getConfig('userData')
      
      if (userData.edit_right)
      {
        this.setState({vat_id:parseInt(vat_id,10)})
      }
    }

    try
    {
      this.setState({authtoken:null})
    }
    catch(err)
    {
      console.log("Error getting stored auth token",err)
    }
  }

  componentDidUpdate(prevProps) {

    let {vat_id} = this.props.match.params

    if(vat_id && prevProps.match.params.vat_id !== vat_id)
    {
      let userData = Config.getConfig('userData')
      
      if (userData.edit_right)
      {
        this.setState({vat_id:parseInt(vat_id,10)})
      }
    }
  }
  
  onGridReady = params => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi
    this.getReturns()
  }

  getReturns = async () => {

    console.log("get returns")

    let returns = await callAccountsApi("vat","getReturns")
    this.setState({returns})
  }

  onRowDoubleClicked = row => {
    this.openVATDetailsPopup(row.data)
  }

  openVATDetailsPopup = selectedVatReturn => {
    this.setState({selectedVatReturn,detail_mode:"view"})
  }

  createNewReturn = async () => {

    try
    {
      this.setState({message:"HMRC integration is disabled"})
    }
    catch(err)
    {
      this.setState({message:"HMRC integration is disabled"})
    }
  }
  
  closeVATDetailsPopup = (refresh) => {
    this.setState({selectedVatReturn:null})

    if (refresh)
    {
      this.getReturns()
    }
  }

  actionClickHandler = (action,vatreturn) => {
    switch(action)
    {
      case "edit" : return this.setState({detail_mode:"edit"})
      case "view" : return this.openVATDetailsPopup(vatreturn)
      case "print" : return this.print(vatreturn.vat_id)
      case "download" : return this.download(vatreturn.vat_id,vatreturn.period)
      case "link" : return this.gotoTransaction(vatreturn)
      default: {}
    }
  }

  gotoTransaction = data => {
    if (data.transaction_id)
    {
      this.props.history.push('/transactions/' + data.transaction_id)
    }
  }

  print = async vat_id => {
    let pdfData = await callAccountsApi("vat","getReturnPDF",{vat_id})

    let pdfDoc = normaliseBinaryPayload(pdfData.data)
    var blob = new Blob([pdfDoc], { type: 'application/pdf' })
    var blob_url = URL.createObjectURL(blob)

    var iframe = document.getElementById('pdfiframe')
    iframe.src=blob_url
    document.body.appendChild(iframe)
    await printIframeDocument(iframe)
  }

  download = async (vat_id,period) => {
    let pdfData = await callAccountsApi("vat","getReturnPDF",{vat_id})
    let filename = `VAT Return ${Moment(period).format("DD-MMM-YYYY")}.pdf`

    let pdfDoc = normaliseBinaryPayload(pdfData.data)
    var blob = new Blob([pdfDoc], { type: 'application/pdf' })
    var blob_url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = blob_url
    a.download = filename

    a.click()
  }

  handleCloseMessage = () => {
    this.setState({message:""})
  }

  render() {
    const { classes } = this.props

    let GridConfig = getGridConfig(this.createNewReturn.bind(this), this.actionClickHandler.bind(this))

    return (
      <React.Fragment>

        <Paper className={classes.paper}>
          <div className="ag-theme-alpine" style={ {height: '100%', width: '100%'} }>
            <AgGridReact
              rowHeight={44}
              onGridReady={this.onGridReady}
              rowData={this.state.returns}
              rowBuffer={GridConfig.visibleRowBufferSize*2}
              columnDefs={GridConfig.columnDefs}
              animateRows={true}
              rowSelection="multiple"
              onRowDoubleClicked={this.onRowDoubleClicked}
              defaultColDef={{filterParams:{ newRowsAction:'keep'}}}
              enableRangeSelection={true}
              statusBar = {{
                statusPanels : [
                  {
                    statusPanel: 'agTotalAndFilteredRowCountComponent',
                    align: 'left',
                  },
                    {
                        statusPanel: 'agAggregationComponent',
                        statusPanelParams : {
                            // only show count and sum ('min', 'max', 'avg' won't be shown)
                            aggFuncs : ['min', 'max', 'avg', 'sum']
                        }
                    }
                ]
              }}
              frameworkComponents = {{
                invoiceActionCellRenderer : ActionCellRenderer,
              }}
              sideBar={{
                toolPanels : ['filters'],
                closedByDefault : true,
              }}

              onFilterChanged = {this.onFilterChanged}
              >
            </AgGridReact>
          </div>

        </Paper>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.message.length > 0}
          onClose={this.handleCloseMessage}
          autoHideDuration={3000}
          message={this.state.message}
        />
            
        <VATDetail vatreturn={this.state.selectedVatReturn} open={this.state.selectedVatReturn !== null} close={this.closeVATDetailsPopup} actionClickHandler={this.actionClickHandler} mode={this.state.detail_mode} authtoken={this.state.authtoken}/>

        <iframe id="pdfiframe" title="pdf"/>

      </React.Fragment>
    )
  }
}

export default withRouter(withStyles(styles)(Vat))
